import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Filter, X } from 'lucide-react';

/**
 * Componente de filtros para usuarios
 * Permite filtrar por username, rol y estado
 */
const UserFilters = ({
  filters = {},
  onFiltersChange,
  onClearFilters,
  onSearch,
  searchPlaceholder = 'Buscar por username...',
  loading = false
}) => {
  // Estado local para los inputs
  const [localUsername, setLocalUsername] = useState(filters.username || '');
  const [localRole, setLocalRole] = useState(filters.role || 'all');
  const [localStatus, setLocalStatus] = useState(filters.status || 'all');

  // Sincronizar estado local cuando cambian los filtros externos
  useEffect(() => {
    setLocalUsername(filters.username || '');
    setLocalRole(filters.role || 'all');
    setLocalStatus(filters.status || 'all');
  }, [filters.username, filters.role, filters.status]);

  const handleClearFilters = () => {
    setLocalUsername('');
    setLocalRole('all');
    setLocalStatus('all');
    onClearFilters();
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setLocalUsername(value);
  };

  const handleRoleChange = (e) => {
    const value = e.target.value;
    setLocalRole(value);
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setLocalStatus(value);
  };

  const handleApplyFilters = () => {
    onFiltersChange({
      ...filters,
      username: localUsername,
      role: localRole,
      status: localStatus,
      applyNow: true
    });
    onSearch();
  };

  const hasActiveFilters = localUsername !== '' || localRole !== 'all' || localStatus !== 'all';

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
          <Filter className="w-5 h-5" />
          Filtros de Usuarios
        </h3>
        {hasActiveFilters && (
          <Button
            onClick={handleClearFilters}
            variant="outline"
            size="sm"
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <X className="w-4 h-4 mr-1" />
            Limpiar Filtros
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Búsqueda por username */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Username
          </label>
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={localUsername}
            onChange={handleUsernameChange}
            className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={loading}
          />
        </div>

        {/* Filtro por rol */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Rol
          </label>
          <select
            value={localRole}
            onChange={handleRoleChange}
            className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={loading}
          >
            <option value="all">Todos los roles</option>
            <option value="admin">Administrador</option>
            <option value="user">Usuario</option>
          </select>
        </div>

        {/* Filtro por estado */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Estado
          </label>
          <select
            value={localStatus}
            onChange={handleStatusChange}
            className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={loading}
          >
            <option value="all">Todos los estados</option>
            <option value="active">Activo</option>
            <option value="inactive">Inactivo</option>
          </select>
        </div>

        {/* Botón de aplicar filtros */}
        <div className="flex items-end">
          <Button
            onClick={handleApplyFilters}
            className="w-full h-10 bg-blue-600 hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Aplicando...
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <Filter className="w-4 h-4" />
                Aplicar Filtros
              </div>
            )}
          </Button>
        </div>
      </div>


    </div>
  );
};

export default UserFilters; 